import { Div, Span, Link, MultipleFilesInput, Snack } from "@tblabs/truffle";
import { OnlineStorage } from "./OnlineStorage";
import { PicturePack } from "./PicturePack";


export class PicsUploader extends Div
{
    constructor(private _storage: OnlineStorage, dir: string, onSuccessfulUpload?: (images: PicturePack[]) => void)
    {
        super();
        this.Background("#ccc").Margin(16).Padding(8);

        this.Append(
            new Div().Append(
                new Span("Add pictures for Watcher page demo").FloatLeft(),
                new Link("✖️").FloatRight().CursorPointer().OnClick(() => this.Hide()),
                new Div().ClearBoth()
            ).Margin(8),
            new MultipleFilesInput(async (files) =>
            {
                new Snack(`Uploading ${files.length} pictures`, "In progress...");

                const uploadResult = await this._storage.UploadManyFiles(files, dir);

                new Snack(uploadResult.IsSuccess ? `✅ Uploaded ${uploadResult.PicturesPacks.length} pictures` : "🔴 Upload error", uploadResult.ErrorMessage);
                if (uploadResult.IsSuccess)
                    onSuccessfulUpload?.(uploadResult.PicturesPacks);
            })
        );
    }
}
